import React from 'react';
import SectionTitle from './SectionTitle';
import { AiFillThunderbolt } from "react-icons/ai";
import { SiAboutdotme } from "react-icons/si";

const technologies = [
    {
        "id": "01",
        "tech": "Javascript"
    },
    {
        "id": "02",
        "tech": "TypeScript"
    },
    {
        "id": "03",
        "tech": "React"
    },
    {
        "id": "04",
        "tech": "Node.js"
    },
    {
        "id": "05",
        "tech": "Express.js"
    },
    {
        "id": "06",
        "tech": "PostgreSQL"
    },
    {
        "id": "07",
        "tech": "MongoDB"
    },    
    {
        "id": "08",
        "tech": "Tailwindcss"
    },
    {
        "id": "09",
        "tech": "PHP"
    },
    {
        "id": "10",
        "tech": "DynamoDB"
    },
    {
        "id": "11",
        "tech": "AWS SAM"
    },
    {
        "id": "12",
        "tech": "GraphQL"
    },
    {
        "id": "13",
        "tech": "Docker"
    },
    {
        "id": "14",
        "tech": "Git"
    },
    {
        "id": "15",
        "tech": "HTML/CSS"
    },
    {
        "id": "16",
        "tech": "Postman"
    },
    {
        "id": "17",
        "tech": "RESTFul APIs"
    },
    {
        "id": "18",
        "tech": "Jest"
    },
    {
        "id": "19",
        "tech": "Sequelize"
    },
    {
        "id": "20",
        "tech": "Mongoose"
    }
]
const About = () => {
  return (
    <section id="about" className='max-w-containerSmall mx-auto py-10 lgl:py-32 flex flex-col gap-8'>
        <SectionTitle title="About Me" emoji={<SiAboutdotme />} />
        <div className='flex flex-col lgl:flex-row gap-16'>
            <div className='w-full lgl:w-2/3 text-base text-textDark font-medium flex flex-col gap-4'>
                <p>
                    Welcome to my space &#127881;! My name is Bunmi Oladipupo and I am a full-stack engineer. My proficiency cuts across both frontend and backend technologies with a flare for cloud computing. I find it interesting using my skills to build impactful solutions that affect the lives of millions of people across the globe.
                </p>
                <p>
                    I spend most of my time coding and trying out new technologies but in my spare time, I either listen to music (afrobeats & hip-hop) or surf the web.
                    
                </p>
                <p>
                    Over the last 3 years, I've had the opportunity to work with these technologies:
                </p>
                <ul className='max-w-[450px] text-sm font-titleFont grid grid-cols-4 gap-2 mt-6'>
                    {
                        technologies.map((tech)=> {
                            return <li key={`${tech.id}`} className='flex items-center gap-2'>
                            <span className='text-textGreen'>
                                <AiFillThunderbolt />
                            </span>
                            {tech.tech}
                        </li>
                        })
                    }
                    
                </ul>
            </div>
            <div className='w-full lgl:w-1/3 h-80 relative group'>
                <div className='absolute w-full h-80 -left-6 -top-6 rounded-lg'>
                    <div className="w-full h-full relative z-20 flex pl-6 lgl:pl-0">
                        <img className="rounded-lg h-full object-cover"
                        src="/profile.jpeg"
                        alt="profile"/>
                        <div className='hidden lgl:inline-block absolute w-full h-80  rounded-md top-0 left-0 group-hover:bg-textGreen/10 duration-300'>

                        </div>
                        
                    </div>

                </div>
                    <div className='hidden lgl:inline-flex w-full h-80 border-2 border-textGreen rounded-md group-hover:-translate-x-2 group-hover:-translate-y-2 transition-transform duration-300'>

                    </div>
            </div>
        </div>

    </section>
  )
}

export default About